var exports = {
  "kL": "xcc377c0b--7de8c6--container",
  "Sl": "xcc377c0b--7de8c6--image",
  "wm": "xcc377c0b--7de8c6--logo",
  "ne": "xcc377c0b--7de8c6--controls",
  "h_": "xcc377c0b--7de8c6--description",
};

module.exports = exports;
